import CoTraderDemo from "./CoTraderDemo";
import CoTraderDemoMobile from "./CoTraderDemoMobile";

const isMobile = window.innerWidth < 768;

const CoTraderDemoPage = () => {
  return (
    <div
      className="w-100 h-100"
      style={{
        width: "100vw",
        height: isMobile ? "100dvh" : "100vh",
        overflow: "hidden",
      }}
    >
      {isMobile ? <CoTraderDemoMobile /> : <CoTraderDemo />}
    </div>
  );
};

export default CoTraderDemoPage;
